import { render, staticRenderFns } from "./ExTextInputWithLimit.vue?vue&type=template&id=396630f8&scoped=true"
import script from "./ExTextInputWithLimit.vue?vue&type=script&lang=js"
export * from "./ExTextInputWithLimit.vue?vue&type=script&lang=js"
import style0 from "./ExTextInputWithLimit.vue?vue&type=style&index=0&id=396630f8&prod&lang=css"
import style1 from "./ExTextInputWithLimit.vue?vue&type=style&index=1&id=396630f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396630f8",
  null
  
)

export default component.exports